const hasPerm = (permToCheck, perms) => {
  if (typeof permToCheck === 'function') {
    return permToCheck(perms);
  }
  return perms.includes(permToCheck);
};

export default hasPerm;
